import { render } from "./ClaimChatDropdown.vue?vue&type=template&id=0af772c9&scoped=true"
import script from "./ClaimChatDropdown.vue?vue&type=script&lang=js"
export * from "./ClaimChatDropdown.vue?vue&type=script&lang=js"

import "./ClaimChatDropdown.vue?vue&type=style&index=0&id=0af772c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af772c9"]])

export default __exports__